import { render, staticRenderFns } from "./CardServices.vue?vue&type=template&id=44cc554c&"
import script from "./CardServices.vue?vue&type=script&lang=js&"
export * from "./CardServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cc554c')) {
      api.createRecord('44cc554c', component.options)
    } else {
      api.reload('44cc554c', component.options)
    }
    module.hot.accept("./CardServices.vue?vue&type=template&id=44cc554c&", function () {
      api.rerender('44cc554c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CardServices.vue"
export default component.exports